export default __webpack_public_path__ + "static/media/about-photo.0586c38f.png";